<template>
  <v-card v-if="selectedLocation.nasid && selectedLocation.nasid > 0" ref="PlanAndPayment" style="background:#f8f8f8" v-bind:class="page">
    <v-snackbar v-model="popup.visible" :color="popup.type" :timeout="3000" :top="'top'" :bottom="false"
      class="custom-snackbar">
      {{ popup.text }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="popup.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
    <div v-if="page != 'gaurenteeCampaign'">
      <v-toolbar fixed flat style="border-radius:0px;background:#fff">
        <v-btn icon @click="close()" v-if="fromSettings">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title dense style="font-size:1.25rem;font-weight:700">
          <span v-text="header"></span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn v-if="!fromSettings" text :style="{ color: 'rgb(199 199 199)' }" class="text-capitalize"
          @click="skipPlanSetting()">
          skip
        </v-btn>
      </v-toolbar>
      <v-card-text style="width:100%;height:auto;max-height: auto;padding:0"
        v-if="page == 'plans' || page == 'send-coupon'">
        <div style="background:#fff;">
          <div style="padding:0 1rem 1rem 1rem">
            <p class="mb-0" style="font-size:0.75rem;font-weight:700" v-if="page == 'plans'">
              Data Usage Plans
            </p>
            <p class="mb-0" style="font-size:0.75rem;font-weight:700" v-if="page == 'send-coupon'">
              Choose data plan and send to customer
            </p>
            <p class="mb-0" style="font-size:0.75rem" v-if="page == 'plans'">
              Customers will choose from the following data usage plans and
              accordingly pay for it
            </p>
          </div>
        </div>
        <div>
          <v-simple-table style="background:#f8f8f8;padding: 0 1rem;font-size:14px;">
            <thead>
              <tr>
                <th class="text-center" v-if="page == 'send-coupon'">Select</th>
                <th>Data Limit<span style="color:#f06b69">*</span></th>
                <th>Validity<span style="color:#f06b69">*</span></th>
                <th>Price<span style="color:#f06b69">*</span></th>
                <!-- <th>Devices<span style="color:#f06b69">*</span></th> -->
                <th class="text-center" v-if="page == 'plans'">Select</th>
              </tr>
            </thead>
            <tbody>
              <tr @click="openConfirmPopup(setting)" v-for="(setting, ind) in plans" :key="'sett' + ind"
                style="height:3rem;font-weight:500">
                <td class="text-center" v-if="page == 'send-coupon'">
                  <input type="radio" name="coupon" v-model="selectedCoupon" color="#f06b69" :value="setting"
                    v-if="page == 'send-coupon'" />
                </td>
                <td>{{ dataFormat(setting.data_limit * 1024 * 1024) }}</td>
                <td>{{ timeFormat(setting.time_limit) }}</td>
                <td>
                  {{ setting.price == 0 ? "Free Plan" : "₹" + setting.price }}
                </td>
                <td class="text-center" v-if="page == 'plans'">
                  <v-checkbox style="margin:auto;width:1.75rem;height:2rem;" v-model="setting.active" color="#f06b69"
                    :value="!setting.active" @click.stop="() => { return false; }"></v-checkbox>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
          <div style="text-align: right;padding-right: 1rem;font-size: .75rem;">
            <v-icon>mdi-info</v-icon>Tap on existing plan to delete
          </div>
          <DataPlanPopup v-if="dataPlanPopupType" ref="dataPlanPopup" v-bind:type="dataPlanPopupType"
            v-bind:coupon="selectedCoupon" v-bind:selectedLocation="selectedLocation" @emitted-plan="
              newPlan => {
                this.plans.push(newPlan);
              }
            "></DataPlanPopup>
        </div>
        <v-card-text style="position:absolute;bottom:2rem;">
          <v-btn block
            style="background:#f06b69 !important;border-color:#f06b69 !important;height:3em;"
            color="error" @click="savePlans()">
            {{ saveText || 'Save' }}
          </v-btn>
        </v-card-text>  
      </v-card-text>
      <v-card-text style="width:100%;height:auto;max-height: auto;padding:0"
        v-if="page == 'payment'">
        <v-simple-table style="background:#f8f8f8;padding: 0 1rem;font-size:14px;">
          <tbody>
            <tr>
              <td style="font-size:0.875rem;font-weight:700">Cash</td>
              <td>
                <v-checkbox v-model="isCash" style="margin:auto;width:1.75rem;height:2rem;" color="#f06b69">
                </v-checkbox>
              </td>
            </tr>
            <tr>
              <td style="font-size:0.875rem;font-weight:700">UPI</td>
              <td>
                <v-checkbox style="margin:auto;width:1.75rem;height:2rem;" color="#f06b69" v-model="isUpi"></v-checkbox>
              </td>
            </tr>

            <tr>
              <td style="font-size:0.875rem;font-weight:700">Online</td>
              <td>
                <v-checkbox v-model="isOnline" style="margin:auto;width:1.75rem;height:2rem;"
                  color="#f06b69" @click.stop="showAcctDetailsPopup()"></v-checkbox>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
        <v-text-field v-if="isUpi" class="mx-3" :rules="[rules.upi]" label="Enter UPI id"
          placeholder="e.g. sharma@icici" v-model="paymentObject.upiId" clearable></v-text-field>

        <v-card-text v-if="isOnline">
          <v-card >
            <v-card-text class="alert-sty">
              <div>Account Holder's Name: <span>{{accountDetails.accountHoldersName}}</span></div>
              <div>Account Number: <span>{{accountDetails.accountNumber}}</span></div>
              <div>IFSC Code: <span>{{accountDetails.ifsc}}</span></div>
              <div>PAN Number: <span>{{accountDetails.panNumber}}</span></div>
              <div v-if="accountDetails.gstNumber">GST Number: <span>{{accountDetails.gstNumber}}</span></div>

              <div style="color:#999999; font-size:.8em;margin-top:1em;"><v-icon style="font-size:1.2em;vertical-align: text-bottom;">mdi-information</v-icon> You can update these details by emailing us at <a href="mailto:contact@i2e1.com">contact@i2e1.com</a></div>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-text style="position:absolute;bottom:2rem;">
          <v-btn block
            style="background:#f06b69 !important;border-color:#f06b69 !important;height:3em;"
            color="error" :disabled="(!isCash && !isUpi && !isOnline) || (isUpi && !paymentObject.upiId) || (isOnline && !accountDetails.accountNumber)" @click="savePaymentMethod()">
            Save
          </v-btn>
        </v-card-text>
      </v-card-text>
    </div>
    <div v-if="page == 'gaurenteeCampaign' && gaurenteeCampaign.page == 'setter'" class="ge-card">
      <div style="font-weight:600;">You are part of</div>
      <div style="font-weight:600;">Guranteed Income Scheme</div>
      <div style="font-weight:600;color: #f4693a;">
        You will get â‚¹500 for next 3 months
      </div>
      <hr style="border-style: dashed; margin: 1rem 0;" />
      <div style="font-weight:600;">Enter UPI Details</div>
      <div>in which you want to receive monthly bonus</div>
      <input v-model="gaurenteeCampaign.upi" placeholder="e.g. rakesh@oksbi"
        style="width: 100%;height: 2.5rem;border: 1px solid grey;border-radius: 4px;padding: 1rem;margin:1rem auto;" />
      <button v-on:click="saveGaurenteeCampaign()"
        style="font-weight:600;color:white;width: 100%;height: 2.5rem;border-radius: 4px;background-image:linear-gradient(0deg, #f4693a, #f4693a);margin-bottom:1rem;">
        Confirm
      </button>
    </div>
    <div v-if="page == 'gaurenteeCampaign' && gaurenteeCampaign.page == 'succ'" class="ge-card">
      <img src="../../assets/wiom_succ.png" style="width: inherit;top: -1rem;left: -1rem;position: relative;" />
      <div>Your special Guaranteed income <br />scheme has been activated.</div>
      <div style="font-weight:600;color: #f4693a;margin:1rem 0;">
        You will get â‚¹500 for next 3 months
      </div>
      <button v-on:click="close()"
        style="font-weight:600;color:white;width: 100%;height: 2.5rem;border-radius: 4px;background-image:linear-gradient(0deg, #f4693a, #f4693a);margin-bottom:1rem;">
        Yah!
      </button>
    </div>
    <Alert :ref="'cnfPopup_' + cnfPopup.ref" v-bind:popupData="cnfPopup" @closed="cnfPopup.show = false"
      @ok="deletePlan(cnfPopup.plan)">
      <v-card-title class="headline px-3 py-3 text-subtitle-1 font-weight-bold" slot="message">
        <div style="margin: 0 auto;text-align:center">
          <p style='margin:1rem 0'>Are you sure<br/>you want to delete this plan?</p>
        </div>
      </v-card-title>
      
    </Alert>
    <Alert :ref="'paymentSucc_' + paymentSucc.ref" v-bind:popupData="paymentSucc" v-bind:hideCancel="true" v-bind:okText="'Ok'" @closed="paymentSucc.show = false"
      @ok="paymentSucc.show=false">
      <v-card-title slot="message">
        <div style="margin: 1em auto;font-size: .6em;text-align:center">
          <h1 style='color: #48bb78'>Success</h1>
          <h2 style='margin-bottom: 1em'>Details saved successfully</h2>
        </div>
      </v-card-title>
    </Alert>
    <Alert :ref="'planSucc_' + planSucc.ref" v-bind:popupData="planSucc" v-bind:okText="'Add more plans'" @closed="planSucc.show = false;close()"
      @ok="planSucc.show=false">
      <v-card-title slot="message">
        <div style="margin: 1em auto;font-size: .6em;text-align:center">
          <h2 style='color: #f2614d'>Congratulations</h2>
          <h2 style=''>Plan successfully updated</h2>
        </div>
      </v-card-title>
    </Alert>
    <AccountDetails v-if="accountDetailsPage.show" :ref="'AccountDetails::'+refresh" v-bind:popupData="accountDetailsPage" @save="(data) => saveAccountDetails(data)"  @closed="accountDetailsPage.show = false" @dismissed="getPaymentModes()"></AccountDetails>
  </v-card>
</template>

<style scoped lang="scss">
  .gaurenteeCampaign {
    display: flex;
    background: #f3f3f3 !important;

    .ge-card {
      background: white;
      font-size: 0.9rem;
      width: 20rem;
      padding: 1rem;
      text-align: center;
      margin: auto;
      display: flex;
      justify-content: center;
      flex-direction: column;
      box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
        0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
    }
  }
  .alert-sty {
    color: black !important;
    div {
      span {
        font-weight: 700;
      }
    }
  }
</style>

<script>
  import async from "async";
  import helper from "../../utils/helper";
  import WIOM_APIS from "../../utils/wiom-apis";
  import DataPlanPopup from "../common/plans/DataPlanPopup";
  import Alert from "../common/Alert";
  import AccountDetails from './AccountDetails';
  export default {
    props: [
      "settingId",
      "selectedLocation",
      "fromSettings",
      "owner",
      "page",
      "subscriptionName",
      "plans"
    ],
    components: {
      DataPlanPopup,
      Alert,
      AccountDetails
    },
    data: () => {
      return {
        refresh: false,
        couponOnlyFlowNasids: [10916,10911,9740,9746,9951,9749],
        popup: {
          type: "error",
          visible: false,
          text: ""
        },
        cnfPopup: {
          ref: 1,
          show: false
        },
        paymentSucc: {
          ref: 1,
          show: false
        },
        planSucc: {
          ref: 1,
          show: false
        },
        skipped: false,
        header: "Data Plans",
        saveText: "Save",
        selectedCoupon: null,
        dataPlanPopupType: null,
        gaurenteeCampaign: {
          upi: "",
          page: "setter"
        },
        paymentObject: {
          account: {}
        },
        accountDetailsPage: {
          show: false
        },
        isUpi: false,
        isCash: false,
        isOnline: false,
        accountDetails: {},
        rules: {
          upi: value => {
            const pattern =
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]{2,})))$/;
            return pattern.test(value) || "Invalid UPI ID";
          }
        }
      };
    },
    mounted: function () {
      this.page = this.page || "plans";
      if (this.fromSettings) this.skipped == false;
      else this.skipped = helper.getCookie("skip-plan") ? true : false;
      this.getPaymentModes();
      this.setupBeforeCall();
    },
    methods: {
      showAcctDetailsPopup: function() {
        if (this.isOnline) {
          this.accountDetailsPage.accountDetails = this.accountDetails;
          console.log(this.accountDetails);
          if(!this.accountDetails || JSON.stringify(this.accountDetails) == "{}")
            this.accountDetailsPage.show = true;
        }
      },
      getPaymentModes: function() {
        let that = this;
        WIOM_APIS.getPaymentModes(this.selectedLocation.nasid).then(response => {
          this.paymentObject = response;
          this.isCash = (this.paymentObject.cash && this.paymentObject.cash == "true");
          this.isUpi = !(!this.paymentObject.upiId);
          if (that.paymentObject.acctInfo) {
            that.paymentObject.acctInfo = that.paymentObject.acctInfo.replaceAll("-",":");
            try {
              that.accountDetails = JSON.parse(that.paymentObject.acctInfo)
              that.isOnline = !(!that.paymentObject.acctInfo);
            } catch(ex) {
              that.accountDetails = {};
              that.isOnline = false;
            }
          } else {
            that.paymentObject.acctInfo = "{}";
            that.accountDetails = {};
            that.isOnline = false;
          }
        });
      },
      showInvalidSelectionPopup: function (errors) {
        let text = "";
        async.forEachOf(
          errors,
          (error, index, cb) => {
            switch (error) {
              case "INSUFFICIENT_PAYMENT_SELECTIONS":
                text += "Choose at least 1 payment mode";
                break;
              case "INSUFFICIENT_SELECTIONS":
                text += "At least 1 plan should be selected";
                break;
              case "EXCESS_FREE_SELECTED":
                text += "Only 1 FREE plan allowed";
            }
            text += "\n";
            cb();
          },
          err => {
            if (err) console.log(err);
            this.popup = {
              type: "error",
              visible: true,
              text: text
            };
          }
        );
      },
      validatePlanSelection: function (validated) {
        let valid = true;
        let freeChecked = 0;
        let checked = 0;
        let isThereAFreePlan = false;
        let errors = [];
        async.forEachOf(
          this.plans,
          function (plan, index, callback) {
            if (plan.active) {
              checked++;
              if (plan.price == 0) {
                isThereAFreePlan = true;
                freeChecked++;
              }
            }
            callback();
          },
          error => {
            if (error) console.log(error);
            if (checked < 1) {
              valid = false;
              errors.push("INSUFFICIENT_SELECTIONS");
            }
            if (isThereAFreePlan && freeChecked != 1) {
              valid = false;
              errors.push("EXCESS_FREE_SELECTED");
            }
            if (!valid) this.showInvalidSelectionPopup(errors);
            return validated(valid);
          }
        );
      },
      dataFormat: helper.dataFormat,
      timeFormat: helper.timeFormat,
      verifyGeCampaign: function () {
        if (
          this.subscriptionName == "WIOM PDO" &&
          !helper.getCookie("ge-campaign-shown-" + this.selectedLocation.nasid)
        ) {
          WIOM_APIS.searchSpreadSheet({
            sheet_name: "gaurentee",
            key: "mobile",
            value: this.owner.ownerNumber
          }).then(res => {
            if (!res.sheet_data.length) {
              this.page = "gaurenteeCampaign";
            } else {
              this.close();
            }
          });
        } else {
          this.close();
        }
      },
      close: function () {
        this.$emit("close");
      },
      skipPlanSetting: function () {
        this.skipped = true;
        helper.setCookie("skip-plan", true, 365);
        this.verifyGeCampaign();
      },
      deletePlan: function (plan) {
        console.log("deleting:", plan);
        this.cnfPopup.ref++;
        this.cnfPopup.show = false;
        this.plans = this.plans.filter(obj => {
          return obj.id != plan.id
        });
        this.savePlans();
      },
      openConfirmPopup: function (plan) {
        if (this.couponOnlyFlowNasids.indexOf(this.selectedLocation.nasid) > 0)
          return;
        if(this.page == 'plans') {
          this.cnfPopup.plan = plan;
          this.cnfPopup.show = true;
          this.cnfPopup.message = "";
          this.cnfPopup.ref++;
          console.log(this.cnfPopup);
        }
      },
      savePlans: function () {
        let that = this;
        if (this.page == "send-coupon") {
          if (this.selectedCoupon) {
            console.log(this.selectedCoupon);
            this.$refs.dataPlanPopup.createCoupon(this.selectedCoupon);
          } else {
            return false;
          }
        } else {
          this.validatePlanSelection(function (result) {
            if (result == true) {
              WIOM_APIS.savePlans(that.selectedLocation.nasid, that.plans).then(
                response => {
                  if (response.data) {
                    if (!that.fromSettings) that.page = "payment";
                    else {
                      that.planSucc.show = true;
                      //that.close();
                    }
                  }
                }
              );
            }
          });
        }
      },
      savePaymentMethod: function () {
        let paymentString =
          `cash:${this.isCash};upiId:${(this.isUpi ? this.paymentObject.upiId : "")};acctInfo:${this.isOnline?this.paymentObject.acctInfo:""}`;
        console.log(paymentString)
        WIOM_APIS.savePaymentModes(this.selectedLocation.nasid, paymentString).then(response => {
          this.getPaymentModes();
          if (response.status == 0) {
            if(this.fromSettings)
              this.paymentSucc.show = true;
            else
              this.verifyGeCampaign();
          }
        });
      },
      saveAccountDetails: function(data) {
        console.log(data);
        this.paymentObject.acctInfo = `${JSON.stringify(data)}`;
        this.paymentObject.acctInfo = this.paymentObject.acctInfo.replaceAll(':', '-');
        this.isOnline = true;
        this.accountDetailsPage.show = false;
        console.log(this.paymentObject.acctInfo);
        this.savePaymentMethod();
      },
      saveGaurenteeCampaign: function (details) {
        if (this.gaurenteeCampaign.upi) {
          details = details || {};
          details.time = new Date();
          details.time = details.time.toISOString().substring(0, 10);
          details.sheet_name = "gaurentee";
          details.to_address = "sajal.sharma@i2e1.com";
          details.mobile = this.owner.ownerNumber;
          details.upi = this.gaurenteeCampaign.upi;
          details.action = "post";
          details.nasid = this.selectedLocation.nasid;
          WIOM_APIS.toSpreadSheet(details);
          this.gaurenteeCampaign.page = "succ";
        } else {
          console.log("UPI not entered");
        }
      },
      setupBeforeCall: function () {
        switch (this.page) {
          case "plans":
            this.header = "Choose Data Plans";
            this.saveText = "Save";
            if (this.fromSettings) this.dataPlanPopupType = "create-plan";
            break;
          case "send-coupon":
            this.header = "Data Plans";
            this.dataPlanPopupType = "send-voucher";
            this.saveText = "Next";
            break;
          case "payment":
            this.header = "Choose Payment Modes";
            break;
        }
      }
    },
    watch: {
      isCash() {
        if (this.isCash == false && this.isUpi == false)
          this.showInvalidSelectionPopup(["INSUFFICIENT_PAYMENT_SELECTIONS"]);
      },
      isUpi() {
        if (this.isCash == false && this.isUpi == false)
          this.showInvalidSelectionPopup(["INSUFFICIENT_PAYMENT_SELECTIONS"]);
      }
    }
  }
</script>